import React from 'react'

function TotalPlacedIcon() {
  return (
    <svg
      width="15"
      height="17"
      viewBox="0 0 15 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_7931)">
        <path
          d="M11.9695 4.49967H9.57553V3.16634C9.57553 2.42634 9.04288 1.83301 8.37856 1.83301H5.98464C5.32032 1.83301 4.78767 2.42634 4.78767 3.16634V4.49967H2.39374C1.72943 4.49967 1.20276 5.09301 1.20276 5.83301L1.19678 13.1663C1.19678 13.9063 1.72943 14.4997 2.39374 14.4997H11.9695C12.6338 14.4997 13.1664 13.9063 13.1664 13.1663V5.83301C13.1664 5.09301 12.6338 4.49967 11.9695 4.49967ZM8.37856 4.49967H5.98464V3.16634H8.37856V4.49967Z"
          fill="#434343"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_7931">
          <rect
            width="14.3636"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default TotalPlacedIcon
